import React, { Component } from 'react'
import LoginTemplate from 'templates/LoginPage'
import LoginCover from 'organisms/LoginCover'
import LoginFormTitled from 'organisms/LoginFormTitled'
import { isCredentialsExists, setCredentialsLocal } from 'utils/localData/credentials'
import { getLoginConfigs, sendLogin, sendLoginAzure, sendVerifyTwoFaCode, sendResendTwoFaCode} from 'Redux/actions/LoginActions'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import lo from 'lodash'
import { withMsal } from "@azure/msal-react";
import { loginScope } from 'services/azureService'

const srcCover = require('App/assets/images/ic_cover_login.png')

export class LoginPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userData: {
        username: '',
        password: ''
      },
      twoFaUserData: {
        email: '',
        expired: ''
      },
      verificationCodeNumber: '',
      isShowClassicLoginModal: false,
      isShowVerificationModal: false,
      isClassicLoginEnable: false,
      isTwoFaLoginEnable: false,
      isBtnDisabled: false,
      isEmptyWarning: false,
      isErrLogin: false,
      isErrMsg: '',
      btnLabel: 'Log In',
      formTitle: 'Mining Operation Collaboration Apps',
      isResendCode: false
    }

    this.handleUserInput = this.handleUserInput.bind(this)
    this.doAuthCall = this.doAuthCall.bind(this)
    this.onLoginWithAzure = this.onLoginWithAzure.bind(this)
    this.autoLoginAzure = this.autoLoginAzure.bind(this)
    this.handleVerificationInput = this.handleVerificationInput.bind(this)
    this.handleVerificationSubmit = this.handleVerificationSubmit.bind(this)
    this.handleResendCode = this.handleResendCode.bind(this)
  }

  componentDidMount() {
    this.props.getLoginConfigs()

    if (!isCredentialsExists()) {
      this.autoLoginAzure();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userLogin !== this.props.userLogin) {
      const { userData, loginConfigs } = this.props.userLogin
      
      if (!lo.isEmpty(loginConfigs)) {
        const isClassicLoginEnable = loginConfigs.some(
          (item) =>
            item.name === "LOGIN_CLASSIC_ENABLE" && item.value.toLowerCase() === "yes"
        );

        const isTwoFaLoginEnable = loginConfigs.some(
          (item) =>
            item.name === "LOGIN_2FA_ENABLE" && item.value.toLowerCase() === "yes"
        );

        this.setState({ isClassicLoginEnable, isTwoFaLoginEnable })
      }

      if (userData) {
        if (userData.code === 401) {
          this.setState({
            isErrLogin: true,
            isErrMsg: userData.message,
            isBtnDisabled: false,
            btnLabel: 'Log In'
          })
        } else if (userData.token) {
          setCredentialsLocal(userData)
          this.navToHome()
        } else if (this.state.isTwoFaLoginEnable) {
          this.setState({
            twoFaUserData: {
              email: userData.email,
              expired: userData.expirationMinutes
            },
            isTwoFaLoginEnable: false
          }, () => {
            if (!this.state.isResendCode) {
              this.switchClassicLoginModal();
              this.switchVerificationModal();
            } else {
              this.setState({ isResendCode: false });
            }
          });
        } 
      }
    }
  }

  navToHome() {
    this.props.history.push('/')
  }

  handleUserInput(value, itemName) {
    let obj = Object.assign(this.state.userData)
    obj[itemName] = value;
    this.setState({ userData: obj });
  }

  handleVerificationInput(value) {
    this.setState({ verificationCodeNumber: value, isErrLogin: false })
  }

  handleVerificationSubmit() {
    this.props.sendVerifyTwoFaCode({
      username: this.state.userData.username,
      code: this.state.verificationCodeNumber
    })
  }

  handleResendCode() {
    this.props.sendResendTwoFaCode({
      username: this.state.userData.username
    })
    this.setState({ 
      isErrLogin: false,
      isErrMsg: '',
      isBtnDisabled: false,
      btnLabel: 'Log In',
      verificationCodeNumber: '',
      isTwoFaLoginEnable: true,
      isResendCode: true,
      twoFaUserData: {
        email: '',
        expired: '0'
      },
    })
  }

  // method for sending the authentication
  doAuthCall(e) {
    e.preventDefault()
    const { userData } = this.state
    const { username, password } = userData
    if (!lo.isEmpty(username) && !lo.isEmpty(password)) {
      this.setState({
        isErrLogin: false,
        isEmptyWarning: false,
        isBtnDisabled: true,
        isErrMsg: '',
        btnLabel: 'Logging in...'
      }, () => {
        this.props.sendLogin(userData)
      })
    } else {
      this.setState({ isEmptyWarning: true })
    }
  }

  switchClassicLoginModal() {
    const { isShowClassicLoginModal } = this.state

    this.setState({ isShowClassicLoginModal: !isShowClassicLoginModal })
  }

  switchVerificationModal() {
    const { isShowVerificationModal } = this.state

    if (isShowVerificationModal) {
      this.setState({ 
        isShowVerificationModal: !isShowVerificationModal,
        isErrLogin: false,
        isErrMsg: '',
        isBtnDisabled: false,
        btnLabel: 'Log In',
        isTwoFaLoginEnable: true,
        isResendCode: false
      })
    } else {
      this.setState({ 
        isShowVerificationModal: !isShowVerificationModal,
        isTwoFaLoginEnable: true,
        isResendCode: false
      })
    }
  }

  onLoginWithAzure() {
    const { instance } = this.props.msalContext;

    instance.loginRedirect(loginScope)
  }

  autoLoginAzure() {
    this.props.toggleIsLoading(true)
    const { instance } = this.props.msalContext;

    instance.ssoSilent(loginScope)
      .then((ssoResponse) => {
        const { accessToken } = ssoResponse;
        this.props.sendLoginAzure(accessToken)
      })
      .finally(() => this.props.toggleIsLoading(false))
  };

  render() {
    return (
      <>
      <LoginTemplate
        leftForm={
          <LoginFormTitled
            title={this.state.formTitle}
            fnOnLoginWithAzure={this.onLoginWithAzure}
            fnOnChange={this.handleUserInput}
            fnOnSubmit={this.doAuthCall}
            fnSwitch={this.switchClassicLoginModal.bind(this)}
            fnVerificationOnChange={this.handleVerificationInput}
            fnVerificationOnSubmit={this.handleVerificationSubmit}
            fnVerificationSwitch={this.switchVerificationModal.bind(this)}
            fnVerificationResendCode={this.handleResendCode}
            valVerification={this.state.verificationCodeNumber}
            valEmail={this.state.twoFaUserData.email}
            countDownTime={this.state.twoFaUserData.expired}
            {...this.state}
          />
        }
        cover={<LoginCover coverSrc={srcCover} />}
      />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      sendLogin,
      sendLoginAzure,
      getLoginConfigs,
      toggleIsLoading,
      sendVerifyTwoFaCode,
      sendResendTwoFaCode
    },
    dispatch
  )

export default withMsal(withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginPage)
))
